import { CreateProductScanDataRequest, QrProductFeedbackRequest } from "./app.model";

const CONTEXT = '[App Store]';

export class GetProduct {
  static readonly type = '[App] Get Product';
  constructor(
    public qrCode: string,
    public tenantId: string,
    /** GS1 digital/standard links include GTIN; scopes product when serials overlap */
    public gtin?: string | null,
  ) {}
}

export class CreateProductScanData {
  static readonly type = '[App] Create Product Scan Data';
  constructor(public payload: CreateProductScanDataRequest, public tenantId: string) {}
}

export class QrProductFeedback {
  static readonly type = '[App] QR Product Feedback';
  constructor(public payload: QrProductFeedbackRequest, public tenantId: string) {}
}

export class SetAuthenticated {
  static readonly type = '[App] Set Authenticated';
  constructor(public isAuthenticated: boolean) {}
}

export class SetTagNotFound {
  static readonly type = '[App] Set Tag Not Found';
  constructor(public isTagNotFound: boolean) {}
}

export class SetQRCode {
  static readonly type = '[App] Set QR Code';
  constructor(public qrCode: string) {}
}

export class SetTenantId {
  static readonly type = '[App] Set Tenant ID';
  constructor(public tenantId: string) {}
}

export class SetPublicScanResults {
  static readonly type = '[App] Set Public Scan Results';
  constructor(public publicScanResults: any) {}
}

export class GetDownloadFilePath {
  static readonly type = '[App] Get Download File Path';
  constructor(public key: string, public bucket: string) {}
}

